import { useEffect, useContext } from 'react';
import { LinearProgress } from '@material-ui/core';
import { CustomerRequestsContext, CustomerRequestsProvider} from './CustomerRequestsContext';
import { NavContext } from '../../contexts';
import { RequestsTable } from './components';

const PageContent = (props) => {
    const {
        setBreadcrumbRoot,
        getCurrentLocation
    } = useContext(NavContext);

    const {
        state,
        isLoadingRequests,
        loadRequests
    } = useContext(CustomerRequestsContext);

    useEffect(() => {
        const location = getCurrentLocation();

        if (location.pathname.includes("/draft")){
            setBreadcrumbRoot("Draft Requests");
            loadRequests("draft", null, 0, 10);
        }
        else if (location.pathname.includes("/running")){
            setBreadcrumbRoot("Running Requests");
            loadRequests("running", null, 0, 10);
        }
        else if (location.pathname.includes("/completed")){
            setBreadcrumbRoot("Completed Requests");
            loadRequests("completed", null, 0, 10);
        }        
    }, []);

    return (
        <>            
            {
                isLoadingRequests &&
                <LinearProgress color="primary" />
            }
            
            {
                state.requests &&
                !isLoadingRequests &&
                <RequestsTable />                
            }
        </>  
    );
}

export const CustomerRequestsPage = (): JSX.Element =>
    <CustomerRequestsProvider>
        <PageContent />
    </CustomerRequestsProvider>;